import { create } from "zustand";

export interface PipStateData {
  selectedConsultId: string;
  isVisible: boolean;
  isResettingConsult: boolean;
  resetRetryCount: number;
}

export interface PipState extends PipStateData {
  setSelectedConsultId: (id: string) => void;
  setIsVisible: (visible: boolean) => void;
  setIsResettingConsult: (isResettingConsult: boolean) => void;
  setResetRetryCount: (resetRetryCount: number) => void;
  reset: () => void;
}

const initialState: PipStateData = {
  selectedConsultId: "",
  isVisible: false,
  isResettingConsult: false,
  resetRetryCount: 0,
};

export const usePipState = create<PipState>((set) => ({
  ...initialState,

  setSelectedConsultId: (selectedConsultId: string) =>
    set({ selectedConsultId }),
  setIsVisible: (isVisible: boolean) => set({ isVisible }),
  setIsResettingConsult: (isResettingConsult: boolean) =>
    set({ isResettingConsult }),
  setResetRetryCount: (resetRetryCount: number) => set({ resetRetryCount }),

  reset: () => {
    set(initialState);
  },
}));
